import { Box, Button, Link, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useCookies } from 'react-cookie';

function CookieConsent() {
  const [cookies, setCookie] = useCookies(['cookie-consent']);
  const [showBanner, setShowBanner] = useState(!cookies['cookie-consent']);

  const handleAccept = () => {
    setCookie('cookie-consent', true, { path: '/', maxAge: 9600 });
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <Paper
          elevation={3}
          sx={{
            position: 'fixed',
            bottom: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            padding: 2,
            maxWidth: 600,
            textAlign: 'center',
            backgroundColor: 'background.paper',
            zIndex: 9999,
          }}
        >
          <Typography variant='body2'>
            A weboldalunk sütiket (cookie-kat) használ, hogy biztonságos
            böngészés mellett a legjobb felhasználói élményt nyújtsa. Az oldal
            használatával elfogadom és tudomásul veszem a cookiek használatát
            valamint a mindenkor érvényes{' '}
            <Link href={process.env.PUBLIC_URL + '/aszf'} target='_blank'>
              ÁSZF
            </Link>{' '}
            -et és{' '}
            <Link href={process.env.PUBLIC_URL + '/gdpr'} target='_blank'>
              Adatvédelmi Tájékoztatót
            </Link>
            .
          </Typography>
          <Box mt={2}>
            <Button variant='contained' color='success' onClick={handleAccept}>
              Tudomásul vettem és elfogadom
            </Button>
          </Box>
        </Paper>
      )}
    </>
  );
}

export default CookieConsent;
